export const mapbox = {
    accessToken: 'pk.eyJ1IjoidGV2dW5hIiwiYSI6ImNtdHNvN29yczAwdmQyeHM3N2hmM2N0ZmsifQ.0k_MDSkhJuIAeLMlG5m_wQ',
    styleUrl: 'mapbox://styles/mapbox/satellite-v9'
};
